import * as React from 'react';

import { compose } from 'redux';
import { Route, RouteComponentProps, Switch, withRouter } from 'react-router';
import IdentityVerifier from '../identity-verifier';
import IdentityVerificationResult from '../identity-verification-result';
import MockIdentityInput from '../mock-input';
import { Config } from '../../lib/config';

export type AppProps = RouteComponentProps<any>;

export interface AppState {
  error?: String;
  config: Config;
}

class Identity extends React.Component<AppProps, AppState> {
  render() {
    const mock =
      process.env.NODE_ENV !== 'production' ? (
        <Route path={'/:lang/mock'} exact component={MockIdentityInput} />
      ) : (
        ''
      );

    return (
      <Switch>
        <Route path={'/:lang'} exact component={IdentityVerifier} />
        <Route
          path={'/:lang/result'}
          exact
          component={IdentityVerificationResult}
        />
        ${mock}
      </Switch>
    );
  }
}

export default compose(withRouter)(Identity);



// WEBPACK FOOTER //
// ./node_modules/eslint-loader!./src/components/identity/index.tsx